var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polyline, _line, _line2, _polygon8, _polygon9, _polygon10, _polygon11, _polyline2, _line3, _line4, _line5, _line6, _line7, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatiment2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "batiment_2",
    "data-name": "batiment 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2398 1986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:#e2e1e5;}.cls-3{fill:#0b6262;}.cls-4{fill:#706d7a;}.cls-5{fill:#4c4b54;}.cls-6{fill:#18a48e;}.cls-7,.cls-9{fill:#b1aaba;}.cls-11,.cls-12,.cls-8{fill:none;}.cls-11,.cls-12,.cls-13,.cls-8,.cls-9{stroke:#4c4b54;stroke-miterlimit:10;}.cls-8{stroke-width:7px;}.cls-11,.cls-13,.cls-9{stroke-width:8px;}.cls-10,.cls-13{fill:#d5d1db;}.cls-12{stroke-width:18px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "batiment 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 1550 749.87 1985.09 824 1931 1567 1931 1645.76 1985.83 2397 1551 2397 694 1202 0 0 693 0 1550"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 1550 749.87 1985.09 827 1873 1202 0 0 693 0 1550"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "673.92 1941.04 674 1083 1723 1083 1723.14 1941.04 1646 1986 1568 1942 830 1941 750 1986 673.92 1941.04"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 709.68 1199 1405 2397 705.76 2397 694 1202 0 0 693 0 709.68"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 710 0 693 1199 1384 2397 694 2397 706 1199 1405 0 710"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1199 1405 1199 1816 1644 1556 1644 1986 1723 1941 1723 1099.26 1199 1405"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "830 1941 830 1600 1199 1816 1568.69 1600 1569 1941 830 1941"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "830 1600 830 1939 1569 1939 1569 1600"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 972.89,
    y1: 1683.64,
    x2: 972.89,
    y2: 1939
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 1421.61,
    y1: 1939,
    x2: 1421.61,
    y2: 1685.93
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1209.29 1809.99 1198.53 1815.72 1189.54 1810.46 1189.54 1935.5 1209.5 1935.5 1209.29 1809.99"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "750 1986 827 1941 826 1598 749.5 1554.5 750 1986"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "750 1470 750 1209 1198.53 1470 1646 1209 1646 1470 1198 1727.58 750 1470"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1202 1473 1642 1216 1642 1468 1207 1718 1202 1473"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "750 1347.48 1199.52 1600 1646 1336.07"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1198,
    y1: 1728,
    x2: 1199,
    y2: 1468
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 896.97,
    y1: 1554.5,
    x2: 896.97,
    y2: 1294.52
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1046.47,
    y1: 1640.46,
    x2: 1046.47,
    y2: 1381.52
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1349.53,
    y1: 1640.46,
    x2: 1349.53,
    y2: 1381.92
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1496.01,
    y1: 1296.49,
    x2: 1496,
    y2: 1554
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1727 1595 2394 1211 2394 1470 1727 1853.25 1727 1595"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1727 1167 2394 782 2394 1042 1727 1425.25 1727 1167"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1928.4 1737.53 1928.4 1478.97 1953.07 1464.76 1953.07 1723.36 1928.4 1737.53"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2154.4 1608.53 2154.4 1349.97 2179.07 1335.76 2179.07 1594.36 2154.4 1608.53"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "674 1595 4 1209 4 1468.29 674 1853.25 674 1595"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "674 1167 4 781 4 1040.29 674 1425.25 674 1167"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "472.6 1737.53 472.6 1478.97 447.93 1464.76 447.93 1723.36 472.6 1737.53"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "246.6 1608.53 246.6 1349.97 221.93 1335.76 221.93 1594.36 246.6 1608.53"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1792.8 1129.09 1792.8 1387.45 1727 1425 1727 1163 1792.8 1129.09"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2167 913.09 2167 1171.45 1941 1302 1941 1049 2167 913.09"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2396.8 781.09 2396.8 1039.45 2331 1077 2331 815 2396.8 781.09"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "611 1134.09 611 1392.45 676.8 1430 676.8 1168 611 1134.09"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "229 909.09 229 1167.45 455 1298 455 1038 229 909.09"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "7 786.09 7 1044.45 72.8 1082 72.8 820 7 786.09"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1723 1112.51 1723 1099 2397 706 2397 714.01 1723 1112.51"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1723 1444.51 1723 1431 2397 1045 2397 1053.01 1723 1444.51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatiment2);
export default __webpack_public_path__ + "static/media/batiment_2.c1a649fea93b94ac3c3fb883633c38f1.svg";
export { ForwardRef as ReactComponent };